

<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [ngStyle]="{'width': col.width ,'display': col.display}"
        [pSortableColumn]="col.field=='lab' ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field=='lab' ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="wrapword" [ngStyle]="{'display': col.display}" *ngIf="col.field != 'active' && col.field != 'lab' && col.field!='byExaminePanel'">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active' || col.field == 'byExaminePanel'">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'lab' ">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="text-left">
      <button type="button" class="h-2rem" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>


<p-dialog header="{{title}} Details" position="top" [baseZIndex]="1000" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade" [modal]="true" [style]="{'width':'650px' ,'height':'1200px'}"  >
  <div *ngIf="masterList">
    <div class="form-group m-2">
      <div class="inputDiv">
        <label>SNP Profile Name</label>
        <div>
          <input pInputText class="form-control" [(ngModel)]="masterList['snpProfileName']"
            (change)="masterList['snpProfileName']=masterList['snpProfileName'].trim()">
        </div>
      </div>
      <div class="inputDiv">
        <label>Upload SNPs</label>
        <div>
          <p-fileUpload #fileUploader (onUpload)="onsnpProfileUpload($event, fileUploader)" (onSelect)="onsnpProfileUpload($event, fileUploader)" mode="basic" customUpload="true" accept=".csv"
          chooseLabel="Upload" auto="true" [style]="{'height':'2rem'}"></p-fileUpload>
          <br>{{uploadedFileName}}
          <br>{{uploadedSize}}
        </div>
      </div>
      <div class="inputDiv">
        <label>Lab</label>
        <div>
          <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" filter="true"  filterBy="label" placeholder="Select a Lab"
            optionLabel="name" [showClear]="true"></p-dropdown>
        </div>
      </div>
      <div class="threshold">
          <label>One parent</label>
        <div>
          <label>Required Markers</label>
          <div>
            <input pInputText type="number" class="form-control" [(ngModel)]="masterList['requiredPercentage']"
            oninput="this.value = this.value.replace(/[^0-9]/, '')"
                (change)="masterList['requiredPercentage']=masterList['requiredPercentage'].trim()">
          </div>
        </div>
        <div>
          <label>Compatible Until</label>
          <div>
            <input pInputText type="number" class="form-control" [(ngModel)]="masterList['compatibleUntil']"
            oninput="this.value = this.value.replace(/[^0-9]/, '')"
                (change)="masterList['compatibleUntil']=masterList['compatibleUntil'].trim()">
          </div>
        </div>
        <div>
          <label>Incompatible Above</label>
          <div>
            <input pInputText type="number" class="form-control" [(ngModel)]="masterList['incompatibleAbove']"
            oninput="this.value = this.value.replace(/[^0-9]/, '')"
                (change)="masterList['incompatibleAbove']=masterList['incompatibleAbove'].trim()">
          </div>
        </div>
      </div>
      <div class="threshold">
        <label>Both parents</label>
      <div>
        <label>Required Markers</label>
        <div>
          <input pInputText type="number" class="form-control" [(ngModel)]="masterList['requiredPercentageBoth']"
          oninput="this.value = this.value.replace(/[^0-9]/, '')"
              (change)="masterList['requiredPercentageBoth']=masterList['requiredPercentageBoth'].trim()">
        </div>
      </div>

      <div>
        <label>Compatible Until</label>
        <div>
          <input pInputText type="number" class="form-control" [(ngModel)]="masterList['compatibleUntilBoth']"
          oninput="this.value = this.value.replace(/[^0-9]/, '')"
              (change)="masterList['compatibleUntilBoth']=masterList['compatibleUntilBoth'].trim()">
        </div>
      </div>

      <div>
        <label>Incompatible Above</label>
        <div>
          <input pInputText type="number" class="form-control" [(ngModel)]="masterList['incompatibleAboveBoth']"
          oninput="this.value = this.value.replace(/[^0-9]/, '')"
              (change)="masterList['incompatibleAboveBoth']=masterList['incompatibleAboveBoth'].trim()">
        </div>
      </div>

    </div>
    <div class="inputDiv">
      <label>Examine By Panel</label>
      <div>
        <p-checkbox [(ngModel)]="masterList['byExaminePanel']" binary="true"></p-checkbox>
      </div>
    </div>
    <div class="inputDiv">
      <label>Active</label>
      <div>
        <p-checkbox [(ngModel)]="masterList['active']" binary="true"></p-checkbox>
      </div>
    </div>

    </div>
  </div>

  <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end">
    <button type="button" pButton icon="pi pi-check"  [disabled]="isSaveDisabled()" (click)="saveMasterList()"
      label="Save" class="h-2rem"></button>
  </div>

</p-dialog>
<p-dialog header="Confirm on SNP Markers" [(visible)]="dialogBoxSnp" [baseZIndex]="1000" [focusOnShow]="false" showEffect="fade" [modal]="true"
[style]="{'width':'436px' ,'height':'179px'}"  >
      Do you really want to replace existing SNP markers?

  <div style="margin-top: 4%;margin-left: 22%;" >
    <button type="button" pButton  (click)="updateSNPData()"
      label="Yes" class="float-left"></button>
  </div>
  <div style="margin-right: 36%;margin-top: 4%;">
    <button type="button" pButton  (click)="updateSNPData()"
      label="No" class="float-right"></button>
  </div>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
